import { render, staticRenderFns } from "./CenterHeader.vue?vue&type=template&id=37427d28"
import script from "./CenterHeader.vue?vue&type=script&lang=js"
export * from "./CenterHeader.vue?vue&type=script&lang=js"
import style0 from "./CenterHeader.vue?vue&type=style&index=0&id=37427d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports